'use client';

import { useTranslations } from 'next-intl';
import Link from 'next/link';
import FAQ from './faq';

const KlarnaDE = () => {
  const t = useTranslations('klarna');

  return (
    <div className="bg-[#f4f6f8]">
      <div className="font-br bg-white p-[0_15px]">
        {/* 标题部分 */}
        <h2 className="pt-[25px] mb-[28px] text-[31px] font-bb">Einkaufen mit Klarna</h2>

        <h3 className="mb-[25px] text-[18px] font-bb">Jetzt kaufen, später bezahlen</h3>
        <p className="mb-[25px] text-[14px] leading-[21px] font-ir">
          Kaufe, was Du liebst, und teile die Kosten auf. Es ist einfach und spannend.
        </p>

        <h2 className="pt-[25px] mb-[28px] text-[31px] font-bb">Wie kaufe ich ein?</h2>

        <h3 className="mb-[25px] text-[18px] font-bb">Schritt 1</h3>
        <p className="mb-[25px] text-[14px] leading-[21px] font-ir">
          Artikel zum Warenkorb hinzufügen
        </p>
        <h3 className="mb-[25px] text-[18px] font-bb">Schritt 2</h3>
        <p className="mb-[25px] text-[14px] leading-[21px] font-ir">
          Gehe zur Kasse und wähle Klarna
        </p>

        <h3 className="mb-[25px] text-[18px] font-bb">Schritt 3</h3>
        <p className="mb-[25px] text-[14px] leading-[21px] font-ir">
          Gib Deine Debit- oder Kreditkarteninformationen ein.
        </p>
        <h3 className="mb-[25px] text-[18px] font-bb">Schritt 4</h3>
        <p className="mb-[25px] text-[14px] leading-[21px] font-ir">
          Deine erste Zahlung wird bei der Bearbeitung der Bestellung abgebucht und die restlichen
          Zahlungen werden automatisch abgebucht
        </p>
        <h2 className="pt-[25px] mb-[28px] text-[31px] font-bb">{t('frequentlyAskedQuestions')}</h2>

        <h3 className="mb-[25px] text-[18px] font-bb">Was ist Klarna?</h3>
        <p className="mb-[25px] text-[14px] leading-[21px] font-ir">
          Klarna ist ein Zahlungsservice, mit dem Du jetzt kaufen und später bezahlen kannst.
        </p>

        <h3 className="mb-[25px] text-[18px] font-bb">Wie funktioniert Klarna?</h3>
        <p className="mb-[25px] text-[14px] leading-[21px] font-ir">
          Du kannst wählen, ob Du innerhalb von 30 Tagen oder in 4 Raten zahlen möchtest.
        </p>

        <h3 className="mb-[25px] text-[18px] font-bb">
          Gibt es Gebühren für die Nutzung von Klarna?
        </h3>
        <p className="mb-[25px] text-[14px] leading-[21px] font-ir">
          Nein, es gibt keine versteckten Gebühren oder Zinsen bei der Nutzung von Klarna.
        </p>

        <h3 className="mb-[25px] text-[18px] font-bb">Wer kann Klarna nutzen?</h3>
        <p className="mb-[25px] text-[14px] leading-[21px] font-ir">
          Du musst 18 Jahre alt sein und andere Kriterien erfüllen, um Klarna nutzen zu können.
        </p>

        <h3 className="mb-[25px] text-[18px] font-bb">
          Was passiert, wenn ich eine Zahlung versäume?
        </h3>
        <p className="mb-[25px] text-[14px] leading-[21px] font-ir">
          Wenn Du eine Zahlung versäumst, können Säumnisgebühren anfallen.
        </p>

        <h3 className="mb-[25px] text-[18px] font-bb">Wie verwalte ich meine Klarna-Zahlungen?</h3>
        <p className="mb-[25px] text-[14px] leading-[21px] font-ir">
          Du kannst Deine Zahlungen über die Klarna App oder die Website verwalten.
        </p>

        <h3 className="mt-[39px] mb-[25px] text-[18px] font-bb">{t('monthlyFinancing')}</h3>
        <p className="mb-[25px] text-[14px] leading-[21px] font-ir">
          {t('monthlyFinancingDescription')}
        </p>

        {/* FAQ 部分 */}

        <h3 className="mb-[25px] text-[18px] font-bb">{t('frequentlyAskedQuestions')}</h3>

        <FAQ />

        {/* 隐私政策链接 */}
        <Link
          prefetch={false}
          href="https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/privacy"
          target="_blank"
          className="mt-[55px] mb-[45px] text-center block font-bb text-[18px] text-primary-black underline"
          rel="nofollow"
        >
          {t('klarnaPrivacyPolicy')}
        </Link>
      </div>
    </div>
  );
};

export default KlarnaDE;
